export * from './angularx-qrcode';
//# sourceMappingURL=index.js.map